import {fetching} from "./index";

import * as routesApi from "../constants/api"

export function listAction() {
    return fetching("CABINET_LIST", routesApi.cabinet.list);
}